var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer"},[_c('span',{staticClass:"the-footer__text"},[_vm._v(_vm._s(_vm.$t('components.footer.memo')))]),_vm._v(" | "),_c('span',{staticClass:"the-footer__text"},[_vm._v(_vm._s(_vm.$t('components.footer.legal')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }